//const SSO_ROOT = "https://sso-test.lightning-e.com";
const SSO_ROOT = "https://sso.lightning-e.com";



function SendAPIRequest( url, method, payload, cb )
{
    var xhr = new XMLHttpRequest( );

    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            //console.log( "rx response " + xhr.responseText );
            var response;
            var err;
            if ( xhr.status == 200 )
            {
                if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                {  
                    if ( xhr.getResponseHeader( "content-type" ) == "application/json" )
                    {
                        try
                        {
                            response = JSON.parse( xhr.responseText );
                        }
                        catch ( e )
                        {
                            console.log( "error parsing response : " + e.stack );
                            err = { "error" : e };
                        }
                    }
                    else
                    {
                        err = { "error" : "invalid content received" };
                        response = xhr.responseText;
                    }
                }
                cb( err, response, xhr );
            }
            else if ( xhr.status == 429 )
            {
                setTimeout( function( )
                {
                    SendAPIRequest( url, method, payload, cb );
                }, 2000 );
            }
            else
            {
                err = { "error" : xhr.status };

                if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                {
                    try
                    {
                        err.detail = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                    }
                }
                cb( err, response, xhr );
            }
        }
    };

    if ( ( method != "GET" ) && ( payload ) )
    {
        xhr.open( method, url, true );
        xhr.setRequestHeader( "x-store", Shopify.shop );
        xhr.setRequestHeader( "Content-Type", "application/json" );
        xhr.send( JSON.stringify( payload ) );
    }
    else
    {
        if ( payload )
        {
            var qpStr = "?";
            for ( var key in payload )
            {
                if ( qpStr.length > 1 )
                {
                    qpStr += "&";
                }
                qpStr += key + "=" + encodeURIComponent( payload[ key ] );
            }
            xhr.open( method, url, true );
        }
        else
        {
            xhr.open( method, url, true );
        }

        xhr.setRequestHeader( "x-store", Shopify.shop );
        xhr.send( );
    }
}

function ShowError( target, error, field )
{
    var schema  = JSON.parse( document.querySelector( "[ data-main-login-schema ]" ).innerHTML );

    var errorEl = document.createElement( "p" );
    errorEl.setAttribute( "class", "account-error" );

    if( error )
    {
        errorEl.innerText = error.detail.error;
    }

    if( field )
    {
        var error_msg = schema[field];
        var anchorEl = '';
        if(schema[field].includes("__link__"))
        {
            console.log("Check string");
            anchorEl = document.createElement( "a" );
            anchorEl.href = schema.recoverURL;
            anchorEl.innerText = schema.recoverURL_text;
            error_msg = error_msg.replace('__link__', ' ');
        }

        errorEl.innerHTML = error_msg;
        if( anchorEl )
        {
            errorEl.appendChild(anchorEl);
        }

    }

    target.appendChild( errorEl );
}

function ClearErrors()
{
    var errors = document.querySelectorAll( ".account-error" )
    {
        errors.forEach( function( error )
        {
            error.parentNode.removeChild( error );
        } );
    }
}

function LoginOverride( e )
{
    e.preventDefault( );
    e.stopPropagation( );

    ClearErrors();

    var form     = e.currentTarget.closest( "form[action*='/account/login']" );
    var email    = form.querySelector( "input[name='customer[email]']" ).value;
    var password = form.querySelector( "input[name='customer[password]']" ).value;

    SendAPIRequest( SSO_ROOT + "/api/login", "POST", { "email" : email, "password" : password, "root" : Shopify.routes.root }, function( err, result )
    {
        if ( result )
        {
            window.location.href = result.url;
        }
        else
        {
            console.log( "login failed with ", err );
            ShowError( form, null, "loginError" );
        }
    } );
}

function RegisterOverride( e )
{
    e.preventDefault( );
    e.stopPropagation( );

    ClearErrors();

    let button = document.querySelector('#create_customer button');
    button.setAttribute("disabled", "true");

    var form    = e.currentTarget.closest( "form[action*='/account']" );
    var payload =
    {
        "root"                 : Shopify.routes.root,
        "registrationSource"   : "web",
        "registrationLanguage" : Shopify.locale,
        "registrationCountry"  : Shopify.country,
        "email"                : form.querySelector( "input[name='customer[email]']" ).value,
        "password"             : form.querySelector( "input[name='customer[password]']" ).value,
        "first_name"           : form.querySelector( "input[name='customer[first_name]']" ).value,
        "last_name"            : form.querySelector( "input[name='customer[last_name]']" ).value,
        "accepts_marketing"    : form.querySelector( "input[name='customer[accepts_marketing]']" ).checked
    };
    
    SendAPIRequest( SSO_ROOT + "/api/signup", "POST", payload, function( err, result )
    {
        if ( result )
        {
            window.location.href = result.url;
        }
        else
        {
            console.log( "register failed with ", err );
            ShowError( form, err );
            button.removeAttribute('disabled');
        }
    } );
}

function DOMApply( root, selector, op )
{
    var elements = root.querySelectorAll( selector );
    elements.forEach( function( element )
    {
        op( element );
    } );
}

function RecoverOverride( e )
{
    e.preventDefault( );
    e.stopPropagation( );

    ClearErrors();

    var form    = e.currentTarget.closest( "form[action*='/account/recover']" );
    var element = form.querySelector( "input[name='email']" );
    var payload = { "email" : element.value };
    
    SendAPIRequest( SSO_ROOT + "/api/reset", "POST", payload, function( err, result )
    {
        if ( result )
        {
            var msg = document.createElement( "h3" );
            msg.setAttribute( "class", "form__message" );
            msg.setAttribute( "tabindex", "-1" );
            msg.innerHTML = `<svg aria-hidden="true" focusable="false" viewBox="0 0 13 13">
                <path d="M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z" fill="#428445" stroke="white" stroke-width="0.7"></path>
                <path d="M5.53271 8.66357L9.25213 4.68197" stroke="white"></path>
                <path d="M4.10645 6.7688L6.13766 8.62553" stroke="white">
                </path></svg>
                We've sent you an email with a link to update your password.`
            
            form.parentNode.insertBefore( msg, form );

            if( result.url )
            {
                window.location.href = result.url;
            }
        }
        else
        {
            ShowError( form, err );
            console.log( "register failed with ", err );
        }
    } );
}

function ParseQPStr( str )
{
    var qpd   = { };
    var qp    = str.substr( 1 );
    var pairs = qp.split( "&" );

    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }

    return ( qpd );
}
function ParseQP( )
{
    return ( ParseQPStr( window.location.search ) );
}

function ResetOverride( e )
{
    e.preventDefault( );
    e.stopPropagation( );

    var form    = e.currentTarget.closest( "form[action*='/account/reset']" );
    var element = form.querySelector( "input[name='customer[password]']" );
    var payload = { "password" : element.value, "token" : ParseQP( ).t };

    SendAPIRequest( SSO_ROOT + "/api/reset", "POST", payload, function( err, result )
    {
        if ( result )
        {
            window.location.href = "/account";
        }
        else
        {
            console.log( "reset failed with ", err );
        }
    } );
}

function loginPageLoadEvents()
{
    if (window.location.href.indexOf("?checkout_url=/tools/recurring/login") > -1)
    {
        var guestLogin_wrapper = document.querySelector('.guest_login--wrapper');

        /* ===== Continue guest content hide ===== */
        if (guestLogin_wrapper)
        {
            guestLogin_wrapper.classList.add('hidden');
        }

        /* ===== Window scroll to ‘Create an account’ section in small screens ===== */
        if (window.screen.width < 990)
        {
            var registerForm = document.querySelector('.customer.register_section');
            var headerHeight = document.querySelector('.section-header').offsetHeight;
            window.scrollTo({ top: registerForm.offsetTop  - headerHeight, behavior: 'smooth' });
        }
    }
}

function StartupSSO( )
{
    window.addEventListener( "load", function( )
    {
        console.log( "sso starting" );
        DOMApply( document, "form[action='/account/login'] button", function( e ) { e.addEventListener( "click", LoginOverride ); } );
        DOMApply( document, "form#create_customer button", function( e ) { e.addEventListener( "click", RegisterOverride ); } );
        DOMApply( document, "form[action='/account/reset'] button", function( e ) { e.addEventListener( "click", ResetOverride ); } );
        DOMApply( document, "form[action='/account/recover'] button", function( e ) { e.addEventListener( "click", RecoverOverride ); } );


    } );

    window.addEventListener( "DOMContentLoaded", function( )
    {
        loginPageLoadEvents();
    });
}
StartupSSO( );
